import { ref, watch, onBeforeMount  } from 'vue';
import { useAlertStore } from '@/rennovation/planning-view/store/useAlertStore';
import { useHistoryApi } from '@/rennovation/common/services/api/useHistoryApi';
import { ApiHistoryResponse } from '@/rennovation/planning-view/types/api/history-response';
import { useI18n } from 'vue-i18n';

interface UseHistoryTabOptions {
	dutyID?: string;
	userID?: string;
	dayID?: string;
}

export function useHistoryTab({ dutyID, userID, dayID }: UseHistoryTabOptions) {
	const filterScope = ref<'duty' | 'user'>('duty');

	const { t } = useI18n();
	const historyApi = useHistoryApi();
	const alertStore = useAlertStore();

	const isLoading = ref(false);
	const currentHistory = ref<ApiHistoryResponse>([]);

	const loadHistory = async (): Promise<void> => {
		isLoading.value = true;
		try {
			if (filterScope.value === 'duty' && dutyID) {
				currentHistory.value = await historyApi.loadHistory({ id: dutyID, model: 'Duty' });
			} else if (filterScope.value === 'user' && userID && dayID) {
				currentHistory.value = await historyApi.loadHistory({ user: userID, day: dayID, model: 'Duty' });
			}
		} catch (error) {
			alertStore.showAlert(error instanceof Error ? error.message : t('unknown_error'), 'error');
		} finally {
			isLoading.value = false;
		}
	};

	onBeforeMount(loadHistory);
	watch(filterScope, loadHistory);

	return {
		filterScope,
		isLoading,
		currentHistory,
	};
}
